export default __webpack_public_path__ + "2055df7e8ccfbe56d72721d3ca1e7e99.png";